import { lazy, Suspense, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { Spinner } from '@/ui/primitives/Spinner';
import { Toaster } from '@/ui/overlays/Toast';

// Marketing layout
const MarketingLayout = lazy(() =>
  import('@/layouts/MarketingLayout').then((m) => ({ default: m.MarketingLayout })),
);

// Marketing pages
const ComingSoonPage = lazy(() =>
  import('@/marketing').then((m) => ({ default: m.ComingSoonPage })),
);
const HomePage = lazy(() =>
  import('@/marketing').then((m) => ({ default: m.HomePage })),
);
const HowItWorksPage = lazy(() =>
  import('@/marketing').then((m) => ({ default: m.HowItWorksPage })),
);
const YourSharePage = lazy(() =>
  import('@/marketing').then((m) => ({ default: m.YourSharePage })),
);
const BridgingFinancePage = lazy(() =>
  import('@/marketing').then((m) => ({ default: m.BridgingFinancePage })),
);
const CommercialMortgagesPage = lazy(() =>
  import('@/marketing').then((m) => ({ default: m.CommercialMortgagesPage })),
);
const DevelopmentFinancePage = lazy(() =>
  import('@/marketing').then((m) => ({ default: m.DevelopmentFinancePage })),
);
const SpecialistBtlPage = lazy(() =>
  import('@/marketing').then((m) => ({ default: m.SpecialistBtlPage })),
);

function PageLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-fog">
      <Spinner size="lg" colour="violet" />
    </div>
  );
}

function HashScroller() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const id = hash.slice(1);
    const tryScroll = () => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    const t = setTimeout(tryScroll, 60);
    return () => clearTimeout(t);
  }, [pathname, hash]);
  return null;
}

export default function App() {
  return (
    <>
      <Toaster />
      <HashScroller />
      <Suspense fallback={<PageLoader />}>
        <Routes>
          {/* Coming soon — public landing */}
          <Route path="/" element={<ComingSoonPage />} />

          {/* Marketing website */}
          <Route element={<MarketingLayout />}>
            <Route path="/preview" element={<HomePage />} />
            <Route path="/how-it-works" element={<HowItWorksPage />} />
            <Route path="/your-share" element={<YourSharePage />} />
            <Route path="/finance/bridging" element={<BridgingFinancePage />} />
            <Route path="/finance/commercial" element={<CommercialMortgagesPage />} />
            <Route path="/finance/development" element={<DevelopmentFinancePage />} />
            <Route path="/finance/btl" element={<SpecialistBtlPage />} />
          </Route>

          {/* Catch-all */}
          <Route path="*" element={<ComingSoonPage />} />
        </Routes>
      </Suspense>
    </>
  );
}
